import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router';

import { LicenseInfo } from '@mui/x-license';

import App from './app';
import { initSentry } from './lib/sentry';
import { routesSection } from './routes/sections';
import { ErrorBoundary } from './routes/components';
import Bridge, { bridgeLoader } from './routes/bridge';

initSentry();
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_LICENSE_KEY);

const router = createBrowserRouter([
  {
    Component: () => (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorBoundary />,
    children: routesSection,
  },
  {
    path: '/bridge/*',
    loader: bridgeLoader,
    element: <Bridge />,
  },
]);

const root = createRoot(document.getElementById('root')!);

root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
